// New RECO VSP modal open event (dispatched when the RECO VSP toggle is enabled).
export const VSP_OPEN_EVENT = 'ents:vsp:open';
// Legacy SUCH VSP drawer open event (dispatched when the RECO VSP toggle is disabled, e.g. PROD).
export const SUCH_VSP_OPEN_EVENT = 'suchen:vsp:alternativeprodukte';

export interface VspOpenEventDetail {
  syan: number;
  colorId?: string;
}

// Payload shape consumed by the legacy SUCH VSP drawer.
export interface SuchVspPayload {
  syan: number;
  farbId?: string;
  listName: string;
}

export interface VspDispatchParams {
  syan: number;
  colorId?: string;
  listName: string;
}

/**
 * Dispatches the correct VSP-open event depending on the runtime toggle.
 *
 * patternLib ships a single JS bundle to every environment, so the client has to decide at runtime
 * which event to emit: when RECO VSP is enabled the `ents-vsp-modal` (RECO) listens for
 * {@link VSP_OPEN_EVENT}; otherwise the legacy SUCH drawer listens for {@link SUCH_VSP_OPEN_EVENT}.
 *
 * Returns the SUCH payload so callers can keep exposing it via their `data-test-*-emitted` hook.
 */
export function dispatchVspOpen(recoVspEnabled: boolean, params: VspDispatchParams): SuchVspPayload {
  const { syan, colorId, listName } = params;
  const suchPayload: SuchVspPayload = {
    syan,
    ...(colorId ? { farbId: colorId } : {}),
    listName,
  };
  if (recoVspEnabled) {
    const detail: VspOpenEventDetail = { syan, ...(colorId ? { colorId } : {}) };
    document.dispatchEvent(new CustomEvent<VspOpenEventDetail>(VSP_OPEN_EVENT, { detail }));
  } else {
    document.dispatchEvent(new CustomEvent<SuchVspPayload>(SUCH_VSP_OPEN_EVENT, { detail: suchPayload }));
  }
  return suchPayload;
}
